import $ from 'jquery';
import 'slick-carousel';

const TABLET_BP = 740;

export default function careers() {
	careersIntro();
	toggleMoreVacancies();
	new meetTheTeamSlider();
}

function careersIntro() {
	const $rootEl = document.querySelector('.careers-intro');
	if (!$rootEl) return false;

	const $image = $rootEl.querySelector('.image');
	const $arrows = {
		left: $rootEl.querySelector('.arrow--left'),
		right: $rootEl.querySelector('.arrow--right'),
	};

	const imageWidth = $image.offsetWidth;
	const maxDis = Math.floor((imageWidth / 2) - (window.innerWidth / 2));
	let transformAmt = 0;
	let intervalFunc;

	const moveLeft = () => setInterval(() => {
		if (transformAmt < maxDis) {
			transformAmt += 2;
			$image.style.transform = `translateX(${transformAmt}px)`;
		}
	}, 10);


	const moveRight = () => setInterval(() => {
		if (transformAmt > -maxDis) {
			transformAmt -= 2;
			$image.style.transform = `translateX(${transformAmt}px)`;
		}
	}, 10);


	// Clear the intervals on mouseout
	Object.values($arrows).forEach(arrow => {
		const arrowDirection = arrow.classList.contains('arrow--right') ? 'right' : 'left';
		const func = arrowDirection === 'right' ? moveRight : moveLeft;

		arrow.addEventListener('mouseover', () => { intervalFunc = func(); });
		arrow.addEventListener('mouseout', () => clearInterval(intervalFunc));
	});
}


function meetTheTeamSlider() {
	var isInitalised = false;
	var $sliderRoot = $('.careers__meet-the-team .o-layout');

	function startTheSlider() {
		if (!isInitalised) {
			$sliderRoot.slick({
				slidesToShow:1,
				autoplay:true,
				autoplaySpeed:3000
			});
		}
		return isInitalised = true;
	}

	function destroyTheSlider() {
		if (isInitalised) {
			$sliderRoot.slick('unslick');
		}
		return isInitalised = false;
	}

	function bpCheck() {
		if (window.innerWidth <= TABLET_BP) {
			startTheSlider();
		} else {
			destroyTheSlider();
		}
	}

	bpCheck();
	$(window).on('resize', bpCheck);
}



function toggleMoreVacancies() {
	var button = document.querySelector('button.see-more-vacancies');
	if (!button)
		return false;

	button.addEventListener('click', function() {

		// Toggle the vacancies
		[...document.querySelectorAll('.to-toggle')].forEach(function(item){
			item.classList.toggle('vacancy-hide');
		});

		// Change the button text
		return this.innerText = (this.innerText.toLowerCase() === 'see more')
			? 'See less' : 'See more';
	});
}